import axios from 'axios'
import {ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  FinishScanDto,
  ModulesByServiceSchedulingDto,
  ModulesByServiceSchedulingResponse,
  RoomsByServiceSchedulingDto,
  RoomsByServiceSchedulingResponse,
  ScanModelDto,
  ScanModelFilter,
  ScanModelResponse,
  ServicePendingDto,
  ServicePendingResponse,
  TotalesPorEstadoFilterDto,
  TotalesPorEstadoResponseData,
  UpdateObservationDto,
} from '../model/multiUserCrew.model'
import {ResponseObject, ResponseObjectPaginatedScan} from '../model/response.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const MULTI_USER_CREW_SERVICES = {
  getListScan: (dto: ScanModelFilter) => {
    return axios.post<ResponseObjectPaginatedScan<ScanModelResponse[]>>(
      `${BASEURL}/Scan/getList`,
      dto,
    )
  },
  createScan: async (dto: ScanModelDto) => {
    return await axios.post<ResponseObjectUpload>(`${BASEURL}/Scan/createScan`, dto)
  },
  getListPendingScan: (dto: ServicePendingDto) => {
    return axios.post<ResponseObjectPaginated<ServicePendingResponse[]>>(
      `${BASEURL}/Scan/getListPendientes`,
      dto,
    )
  },
  getListTotalesPorEstado: (dto: TotalesPorEstadoFilterDto) => {
    return axios.post<ResponseObject<TotalesPorEstadoResponseData>>(
      `${BASEURL}/Scan/getListTotalesPorEstado`,
      dto,
    )
  },
  updateObservation: (dto: UpdateObservationDto) => {
    return axios.post<ResponseObjectUpload>(`${BASEURL}/Scan/UpdateObservacion`, dto)
  },
  finishScan: (dto: FinishScanDto) => {
    return axios.post<ResponseObjectUpload>(`${BASEURL}/Scan/FinalizarScan`, dto)
  },
  getModules: (dto: ModulesByServiceSchedulingDto) => {
    return axios.post<ResponseObject<ModulesByServiceSchedulingResponse[]>>(
      `${BASEURL}/assignment/getDistinctModuloIdsByServiceScheduling`,
      dto,
    )
  },
  getRooms: (dto: RoomsByServiceSchedulingDto) => {
    return axios.post<ResponseObject<RoomsByServiceSchedulingResponse[]>>(
      `${BASEURL}/assignment/getDistinctHabitacionIdsByServiceSchedulingAndModulo`,
      dto,
    )
  },
}
